// These should be in sync with our design library media queries
export default {
  tabletSmall: 460,
  tabletLarge: 769,
  desktopSmall: 1025,
};
